// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SeoPrefooter_wrapper__y0LLG"};